import { Modal, Radio, Divider, Tag, Checkbox, Input } from "antd";
import { CloseOutlined, PlusOutlined, RightCircleOutlined } from "@ant-design/icons";
import SpiceRed from "../../../assets/images/spice-red.svg";
import Spice from "../../../assets/images/spice.svg";

const tags = ["Chicken", "Chease", "Peanut", "Black Bears"];
const beanTypes = ["Black Beans", "No Beans", "Extra Beans", "Light Beans"];

export default function MenuDetail({ open, onClose ,selectedMenu,addtoCart}) {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      width={420}
      className="customize-modal"
    >
      {/* Top Image */}
      <div className="modal-image">
        <img src={selectedMenu?.photo_url} alt="food" />
        <CloseOutlined  style={{color:"black"}} className="close-btn" onClick={()=>onClose(false)} />
      </div>

      {/* Name & Description */}
      <div className="modal-body">
        <div className="item-name">Mexican Chicken Bowl</div>
        <div className="item-desc">
          Freshly cooked chicken with rich Mexican spices
        </div>

        {/* Tags */}
        <div className="item-tags">
          {tags.map(tag => (
            <span key={tag} className="blue-tag">{tag}</span>
          ))}
        </div>

        <Divider />

        {/* Customize */}
        <div className="section-header">
          <span>Do you want to Customize?</span>
          <span className="required">*required</span>
        </div>

        <Radio.Group className="radio-group">
          <Radio value="yes">Yes</Radio>
          <Radio value="no">No</Radio>
        </Radio.Group>

        <Divider />

        {/* Spice Level */}
        <div className="section-title">Spice level</div>
        <div className="spice-level">
          {[1,2,3,4,5].map(i => (
            <img
              key={i}
              src={Spice}
              alt="spice"
              className="spice-img"
            />
          ))}
        </div>

        <Divider />

        {/* Beans */}
        <div className="section-title">Choose One bean type</div>
        <div className="bean-tags">
          {beanTypes.map(bean => (
            <Tag key={bean} className="bean-tag">
              {bean} <PlusOutlined />
            </Tag>
          ))}
        </div>

        <Divider />

        {/* Add ons */}
        <div className="section-title">Add ons</div>

        <Checkbox className="addon">
          <div>Add On</div>
          <div className="price">+ $2.99</div>
        </Checkbox>

        <Checkbox className="addon">
          <div>Extra Dip</div>
          <div className="price">+ $1.99</div>
        </Checkbox>

        <Checkbox className="addon">
          <div>Extra Salad</div>
          <div className="price">+ $3.99</div>
        </Checkbox>

        <Divider />

        {/* Special Instruction */}
        <div className="section-title">Any Special Instruction</div>
        <Input.TextArea
          placeholder="Add any special instructions if required here"
          className="instruction"
        />
      </div>

       <div className="bottom-fixed-wrapper">
          {/* Top Menu Section */}
          

          {/* Cart Section */}
          <div className="cart-bar">
            <div className="cart-left">
              <span className="items">
                {selectedMenu?.name} 
              </span>
              <span className="price mobile-price">${selectedMenu?.price ?? 0}</span>
            </div>

            <div className="cart-right" onClick={()=> {addtoCart(selectedMenu);
                onClose(false)
            }}>
              <span>Add to Cart</span>
              <PlusOutlined />
            </div>
          </div>
        </div>
    </Modal>
  );
}
